"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _index = require("../../../../index");

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _bind["default"].bind(_style["default"]);

var ErrorMessage = function ErrorMessage(_ref) {
  var onRefresh = _ref.onRefresh;
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-upsell-error-message')
  }, void 0, /*#__PURE__*/_jsx("img", {
    src: require('../../../../_icons/alert--red.svg'),
    alt: "error"
  }), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-upsell-error-message__title')
  }, void 0, "Internal error"), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-upsell-error-message__description')
  }, void 0, "Looks like something went wrong on our end. We are already working on a solution."), /*#__PURE__*/_jsx(_index.Button, {
    appearance: "flatten",
    onClick: onRefresh
  }, void 0, "Try to refresh the page"));
};

var _default = ErrorMessage;
exports["default"] = _default;